import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
// import { TranslateService } from "@ngx-translate/core";
// import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from "rxjs";
import { avatarType } from '../../shared/components/avatar/types/avatar.type';
import { BreadcrumbService } from '../../shared/components/breadcrumbs/breadcrumbs.service';
import { ConfirmService } from '../../shared/components/confirm/services/confirm.service';
import { PopupService } from '../../shared/components/popup/services/popup.service';
import { AppDataService } from '../services/app-data.service';
import { LayoutService } from '../services/layout.service';
import { MessagingService } from '../services/messaging.service';
import { ThemeService } from '../services/theme.service';
// import { AlertService } from 'src/app/shared/components/alert/alert.service';
// import { BreadCrumbsService } from 'src/app/shared/components/bread-crumbs/bread-crumbs.service';
// import { AuthService } from "../services/auth.service";
// import { Guid } from 'guid-typescript';

@Component({
    selector: 'epmax-base',
    template: '',
    standalone: false
})
export abstract class BaseComponent implements OnInit {

    avatarTypeEnum = avatarType;

    //   public readonly _alertService: AlertService;
    //   public readonly _authService: AuthService;
    public readonly _route: ActivatedRoute = inject(ActivatedRoute);
    public readonly _router: Router = inject(Router);
    public readonly _toaster: ToastrService = inject(ToastrService);
    public readonly _dialog: PopupService = inject(PopupService);
    public readonly _confirm: ConfirmService = inject(ConfirmService);
    public readonly _appData: AppDataService = inject(AppDataService);
    public readonly _breadcrumbService: BreadcrumbService = inject(BreadcrumbService);
    public readonly _layoutService: LayoutService = inject(LayoutService);
    public readonly _translateService: TranslateService = inject(TranslateService);

    public readonly _messageService: MessagingService = inject(MessagingService);
    public readonly _theme: ThemeService = inject(ThemeService);
    
    //   public readonly _toster: ToastrService;
    //   public readonly _breadCrumbs: BreadCrumbsService;
    //   public readonly _translate: TranslateService;
    //   public readonly emptyGuid: string = Guid.EMPTY;

    public UIform: FormGroup = new FormGroup({//for UI TEAM
        control: new FormControl(null)
    });


    protected constructor() { }

    private subscriptionsList: Array<Subscription> = [];

    public set subscription(v: Subscription) {
        this.subscriptionsList[this.subscriptionsList.length] = v;
    }

    ngOnInit() {
        this.ngSuperOnInit();
    }
    ngAfterViewInit() {
        this.ngSuperAfterViewInit();
    }
    ngOnDestroy() {
        this.subscriptionsList.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.ngSuperOnDestroy();
    }

    protected abstract ngSuperOnInit(): any;
    protected abstract ngSuperAfterViewInit(): any;
    protected abstract ngSuperOnDestroy(): any

}
